export default function getVersion(version) {
    return version?version:'v1'
}
